import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { AuthRoutingModule } from './auth-routing.module';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { SendEmailComponent } from './components/send-email/send-email.component';
import { VerifyCodeComponent } from './components/verify-code/verify-code.component';
import { AuthComponent } from './containers/auth-wrapper/auth.component';
import { ChangePasswordContainerComponent } from './containers/change-password/change-password-container.component';
import {
  EmailVerificationTokenComponent,
} from './containers/email-verification-token/email-verification-token.component';
import { EmailVerificationComponent } from './containers/email-verification/email-verification.component';
import { LoginComponent } from './containers/login/login.component';
import { RegistrationComponent } from './containers/registration/registration.component';
import { SendEmailContainerComponent } from './containers/send-email/send-email-container.component';
import { VerifyCodeContainerComponent } from './containers/verify-code/verify-code-component-container.component';
import { TokenInterceptor } from './interfaces/token.interceptor';
import { GlobalErrorHandler } from './services/global-error-handler.service';
import { StepEmailComponent } from './components/registration-steps/step-email/step-email.component';
import { StepPhoneComponent } from './components/registration-steps/step-phone/step-phone.component';
import {
  StepPhoneVerificationComponent,
} from './components/registration-steps/step-phone-verification/step-phone-verification.component';
import { StepPasswordComponent } from './components/registration-steps/step-password/step-password.component';
import {
  StepEmailVerificationComponent,
} from './components/registration-steps/step-email-verification/step-email-verification.component';
import { StatementsComponent } from './components/statements/statements.component';
import { MatTableModule } from '@angular/material/table';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { RemovedAccountComponent } from './containers/removed-account/removed-account.component';
import { ContainerComponent } from '../shared/components/container/container.component';
import { MatCardActions, MatCardContent } from '@angular/material/card';


@NgModule({
  declarations: [
    RegistrationComponent,
    LoginComponent,
    AuthComponent,
    EmailVerificationComponent,
    EmailVerificationTokenComponent,
    SendEmailComponent,
    VerifyCodeContainerComponent,
    ChangePasswordContainerComponent,
    SendEmailContainerComponent,
    VerifyCodeComponent,
    ChangePasswordComponent,
    StepEmailComponent,
    StepPhoneComponent,
    StepPhoneVerificationComponent,
    StepPasswordComponent,
    StepEmailComponent,
    StepEmailVerificationComponent,
    StatementsComponent,
    RemovedAccountComponent
  ],
  exports: [
    ChangePasswordComponent, SendEmailComponent, VerifyCodeComponent, StatementsComponent
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaskDirective, NgxMaskPipe,
    MatTableModule, ContainerComponent,
    MatCardContent, MatCardActions
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      multi: true,
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
    },
    provideNgxMask()
  ],
})
export class AuthModule {
  constructor() {
  }
}
